export function formatBRL(value: number){
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
    value,
  );
}

export function isRs(origem: string, destino: string){
  const ufOrigem = getUf(origem);
  const UfDestino = getUf(destino);

  return ufOrigem === 'RS' && UfDestino === 'RS';
}

export function getUf(cidade: string){
  const split = cidade.split('-');

  if(Array.isArray(split)){
    const uf = split[1].trim();
    
    return uf;
  }

  return '';
}